export default __webpack_public_path__ + "13539f94a86cf4c836be0041bd477bd0.svg";